import { getOrgEmployees, getOrgGroups} from "../services/globalData";

// Returns an array in every case. The directory cache is cleared on each
// employee write, so callers can land here between the write and the refetch;
// handing them undefined turns that moment into a crash somewhere downstream.
export const getEmployeeListFromDepartments = (department) => {
  return (getOrgEmployees() || []).filter((emp) => department?.includes(emp.department));
};

export const getEmployeeListFromGroups = (employeegrp) => {
  const orgGroups = getOrgGroups() || [];
  const allEmployees = getOrgEmployees() || [];

  // Filter groups based on employeegrp array
  const selectedGroups = orgGroups.filter(group => employeegrp.includes(group._id));
  console.log(selectedGroups);

  // Extract employee IDs from the selected groups
  const employeeIds = selectedGroups.flatMap(group => group.employee);
  console.log(employeeIds);

  // Filter employees based on the extracted employee IDs
  const employeesInfo = allEmployees.filter(employee => employeeIds.includes(employee._id));
  console.log(employeesInfo);

  return employeesInfo;
};